/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useCallback } from 'react';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { createUrl } from '../../redux/helper/CreateQuery';

function TransactionFiltermodal({
    filterModal, setFilterModal, Filter, setFilter, filterValue, setfilterValue, handleFilter, handleFetchTransactionsList, SetSuccessMessage,
}) {
    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateUrl = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'transaction_status':
                if (Filter[key].length > 0) {
                    final += `&status=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
        });
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filter(s) Applied!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    const handleClear = () => {
        setFilter({
            transaction_status: [],
        });
        setfilterValue('');
        handleFetchTransactionsList();
        setFilterModal(false);
        SetSuccessMessage('All Fitlers Cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[575px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation">
                                    <a href="#pills-pricetab" className="nav-link block text-base font-semibold text-[#AAA6AF] order active relative w-full" id="pills-ordercategory" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab" aria-controls="pills-pricetab" aria-selected="true">
                                        Transaction Status
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className="tab-pane fade show active px-3" id="pills-pricetab" role="tabpanel" aria-labelledby="pills-ordercategory">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            <div
                                                className="flex items-center mb-3"
                                                onClick={() => HandleFilter('transaction_status', '2')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.transaction_status?.includes('2') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.transaction_status.includes('2')}
                                                    borderColor={`${Filter.transaction_status.includes('2') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn1" data-testid="assigned" className="consumbales pl-3 text-lg font-normal text-[#090406] text-left cursor-pointer">Assigned</label>
                                            </div>
                                            <div
                                                className="flex items-center mb-3"
                                                onClick={() => HandleFilter('transaction_status', '0')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.transaction_status?.includes('0') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.transaction_status.includes('0')}
                                                    // onChange={() => HandleFilter('transaction_status', '0')}
                                                    borderColor={`${Filter.transaction_status.includes('0') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn2" data-testid="unassigned" className="consumbales pl-3 text-lg font-normal text-[#090406] text-left cursor-pointer">Unassigned</label>
                                            </div>
                                            <div
                                                className="flex items-center mb-3"
                                                onClick={() => HandleFilter('transaction_status', '1')}
                                            >
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.transaction_status?.includes('1') ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.transaction_status.includes('1')}
                                                    onChange={() => HandleFilter('transaction_status', '1')}
                                                    borderColor={`${Filter.transaction_status.includes('1') ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn3" data-testid="partial" className="consumbales pl-3 text-lg font-normal text-[#090406] text-left cursor-pointer">Partial</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[40%] mr-4">
                                <button
                                    data-testid="clear"
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    data-testid="apply"
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateUrl()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TransactionFiltermodal;
